import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import store from './store';
import router from './router';
import { createAxiosPlugin } from './plugins/axios';
import 'filters';
import echarts from 'echarts';
import JsonExcel from 'vue-json-excel'


Vue.component('downloadExcel', JsonExcel)

Vue.prototype.$echarts = echarts;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(createAxiosPlugin());

// // eslint-disable-next-line
Vue.config.productionTip = process.env.NODE_ENV === 'production';

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');


